import { SortingState } from "@tanstack/react-table";
import PageCard from "PFComponents/page/page_card";
import Table from "PFComponents/table";
import { Typography } from "PFComponents/typography";
import { CustomValue } from "PFTypes";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { getOrderForRequest, getOrderForTable } from "../helpers/get_order";
import { useSkillsManagementContext } from "./contexts/skills_management_context_provider";
import { SkillsManagementTableHeader } from "./header/skills_management_table_header";
import { useTableData } from "./hooks/use_table_data";
import css from "./skills_management_table.module.scss";

export const SkillsManagementTable = () => {
  const { t } = useTranslation("skillsManagement");
  const {
    currentPage,
    setCurrentPage,
    setOrder,
    setRowSelectionState,
    rowSelectionState,
    orderOptions,
    order
  } = useSkillsManagementContext();
  const [columnSorting, setColumnSorting] = useState<SortingState>(getOrderForTable(order));

  useEffect(() => {
    setOrder(getOrderForRequest(columnSorting, orderOptions));
  }, [columnSorting, orderOptions, setOrder]);

  const { skills, generateColumns, totalPages, isLoading } = useTableData();

  const isEmpty = (!skills || skills.length === 0) && !isLoading;

  return (
    <PageCard variant="spaced" classes={{ card: css.tableCard }}>
      <SkillsManagementTableHeader />
      <Table<CustomValue>
        tableData={skills || []}
        generateColumns={generateColumns}
        paginationOptions={{ currentPage, totalPages, onClick: setCurrentPage }}
        onSortingChange={setColumnSorting}
        controlledSorting={columnSorting}
        onRowSelectionChange={setRowSelectionState}
        getRowId={(skill) => (skill.id ? `${skill.id}` : skill.global_id || "")}
        rowSelection={rowSelectionState}
        enableRowSelection={true}
        enableMultiRowSelection={true}
      />
      {isEmpty && (
        <Typography className={css.emptyTableCopy} variant={"bodyRegular"} tag="p">
          {t("emptyTable")}
        </Typography>
      )}
    </PageCard>
  );
};
